import { render, staticRenderFns } from "./mg-button.vue?vue&type=template&id=04083b58&scoped=true&"
import script from "./mg-button.vue?vue&type=script&lang=js&"
export * from "./mg-button.vue?vue&type=script&lang=js&"
import style0 from "./mg-button.vue?vue&type=style&index=0&id=04083b58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04083b58",
  null
  
)

export default component.exports